<template>
  
<span>

	<b-row cols="12" 
		align-h="end">
		
		<b-col 
			cols="6"
			style="text-align:right">
			
			<small>
				<b-link :to="{name: 'signup', params: {action: 'signup'}}">Sign up</b-link>
				|
				<b-link :to="{name: 'signup', params: {action: 'signin'}}">Log in</b-link>
			</small>

			
		</b-col>
	</b-row>
	
	<b-row cols="12" align-h="between">
		
		<b-col 
			order="2"
			order-md="1"
			cols="12" 
			md="7" 
			align-self="center">

			<p class="display-4">
				Principal Task
			</p>

			<p style="font-size:1.25rem">
				A task manager built for productive people (or those who want to be).
			</p>

			<p>
				Principal Task is a mobile-friendly task manager without complexity.  It's available on all of your devices &mdash; without the need for a nosey app &mdash; and 
				ready any time you need to update your list or catch up on your day.
			</p>

			<p>
				Click or tap <b-link :to="{name: 'signup', params: {action: 'signup'}}">here</b-link> to get started.
				Scroll to learn about features and pricing.
			</p>


		</b-col>

		<b-col 
			order="1"
			order-md="2"
			cols="12" 
			md="4" 
			align-self="end"
			style="">

			<b-img 
				:src="require('../../assets/logos/PTLogo-NoText-Cropped.png')"
				class="img-fluid"
				style="max-width: 22rem"/>

		</b-col>

	</b-row>

	<b-row class="mt-3">
		<b-col cols="12">
			<p class="display-4">
				Features
			</p>

			<p style="font-size:1.25rem">
				Principal Task has all of the features you need to stay organized and productive.  
			</p>

			<p>
				Click or tap each feature to learn how it helps you.
			</p>

		</b-col>
	</b-row>
	
	<b-row align-h="around">

		<b-col
			cols="12">
			
					<b-list-group>
						

						<b-overlay
							:show="features.contexts"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('contexts')">

								Contexts
								<b-icon icon="at"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.contexts}}
							</template>

						</b-overlay>
						
						<b-overlay
							:show="features.filters"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('filters')">

								Custom Filters
								<b-icon icon="filter"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.filters}}
							</template>

						</b-overlay>

						<b-overlay
							:show="features.dashboard"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('dashboard')">

								Dashboard
								<b-icon icon="pie-chart-fill"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.dashboard}}
							</template>

						</b-overlay>
						
						<b-overlay
							:show="features.import"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('import')">

								Data Import
								<b-icon icon="box-arrow-down"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.import}}
							</template>

						</b-overlay>
						
						<b-overlay
							:show="features.dates"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('dates')">

								Dates
								<b-icon icon="calendar"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.dates}}
							</template>

						</b-overlay>
						
						<b-overlay
							:show="features.folders"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('folders')">

								Folder
								<b-icon icon="folder"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.folders}}
							</template>

						</b-overlay>

						<b-overlay
							:show="features.markdown"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('markdown')">

								Markdown
								<b-icon icon="markdown-fill"/>
							</b-list-group-item>

							<template v-slot:overlay>
								Format your comments with
								<b-link href="https://www.markdownguide.org/" target="_new">
								Markdown</b-link>
							</template>

						</b-overlay>

						<b-overlay
							:show="features.mobile"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('mobile')">

								Mobile-friendly
								<b-icon icon="phone"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.mobile}}
							</template>

						</b-overlay>	

						<b-overlay
							:show="features.nestedFolders"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('nestedFolders')">

								Nested Folders
								<b-icon icon="list-nested"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.nestedFolders}}
							</template>

						</b-overlay>

						<b-overlay
							:show="features.priorities"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('priorities')">

								Priority
								<b-icon icon="exclamation"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.priorities}}
							</template>

						</b-overlay>

						<b-overlay
							:show="features.reminders"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('reminders')">

								Reminders
								<b-icon icon="alarm-fill"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.reminders}}
							</template>

						</b-overlay>

						<b-overlay
							:show="features.repeatingTasks"
							:opacity="opacity"
							:variant="variant">
							
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('repeatingTasks')">

								Repeating Tasks
								<b-icon icon="arrow-repeat"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.repeatingTasks}}
							</template>

						</b-overlay>

						<b-overlay
							:show="features.stars"
							:opacity="opacity"
							:variant="variant">
						
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('stars')">

								Star
								<b-icon icon="star"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.stars}}
							</template>

						</b-overlay>

						<b-overlay
							:show="features.statuses"
							:opacity="opacity"
							:variant="variant">
						
							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('statuses')">

								Status
								<b-icon icon="circle-half"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.statuses}}
							</template>

						</b-overlay>
						
						<b-overlay
							:show="features.subTasks"
							:opacity="opacity"
							:variant="variant">

							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('subTasks')">
								Sub-tasks
								<b-icon icon="file-plus"/>
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.subTasks}}
							</template>
						</b-overlay>

						<b-overlay
							:show="features.visibility"
							:opacity="opacity"
							:variant="variant">

							<b-list-group-item 
								class="d-flex justify-content-between align-items-center"
								@click="over('visibility')">
								
								Visibility
								
								<b-icon icon="arrows-expand"/>
							
							</b-list-group-item>

							<template v-slot:overlay>
								{{featureText.visibility}}
							</template>

						</b-overlay>

						

						

						

						

						
						

						

						

					</b-list-group>

		</b-col>

	</b-row>

	<b-row align-h="around" cols="12">
		<b-col cols="12"
			style="text-align:center;">
			<b-button :to="{name: 'signup', params: {action: 'signup'}}" 
                            variant="success" class="mt-3">Get Started</b-button>
		</b-col>
	</b-row>

	<b-row class="mt-3">
		<b-col cols="12">
			<p class="display-4">
				Pricing
			</p>

			<p style="font-size:1.25rem">
				Subscriptions for every budget.
			</p>

		</b-col>
	</b-row>

	<b-row align-h="around">

		<b-col
			cols="12">
			
			<b-card-group deck>
                
                
  

                
                
                <b-card
                    style="color:black">

                    <h4>
                        <b-link :to="{name: 'signup', params: {action: 'signup', tier: 'free'}}">Early Adopter</b-link>
                    </h4>
                    <h6 class="text-secondary">Free Tier</h6>

                    <b-card-text>
                        All of the features of Principal Task with none of the cost.  
                        Recommended for students, individuals with low income, or those who desire
                        to give Principal Task a try.
                    </b-card-text>

                    
                </b-card>

                <b-card
                    style="color:black">
                                
                    <h4>
                        <b-link :to="{name: 'signup', params: {action: 'signup', tier: 'paid'}}">Early Patron</b-link>
                    </h4>
                    
                    <h6 class="text-secondary">Paid Tier</h6>
                    
                    <b-card-text>
                        All of the features of Principal Task as well as the added 
                        benefits of knowing that you are supporting both the growth
                        of a small company and the improvement of Principal Task.  
                    </b-card-text>

                    
                </b-card>

                </b-card-group>
		</b-col>

	</b-row>

	<b-row align-h="around" cols="12">
		<b-col cols="12"
			style="text-align:center;">
			<b-button :to="{name: 'signup', params: {action: 'signup'}}" 
                            variant="success" class="mt-3">Get Started</b-button>
		</b-col>
	</b-row>

</span>
</template>
<script>

	import Menu from '@/components/Menu.vue'

	export default {
		name: 'Landing2',
		components: {
            Menu
		},
		props: {
		},
		data () {
			return {
				features: {
					contexts: false,
					dashboard: false,
					dates: false,
					import: false,
					filters: false,
					folders: false, 
					markdown: false,
					mobile: false,
					nestedFolders: false, 
					priorities: false,
					reminders: false, 
					repeatingTasks: false,
					stars: false,
					statuses: false,
					subTasks: false,
					visibility: false,
				},
				featureText: {
					contexts: 'Organize tasks based on your context.',
					dashboard: 'Review your obligations and productivity.',
					dates: 'Keep of track start and due dates/times.',
					import: 'Import your data from other task managers.',
					filters: 'Customize the tasks you see.',
					folders: 'Organize like tasks',
					markdown: 'HARDCODED',
					mobile: 'Use any device you have available.',
					nestedFolders: 'Group like folders.',
					priorities: 'Organize tasks based on their importance.',
					reminders: 'Reminders help you to never miss a deadline',
					repeatingTasks: 'Automatically create recurring tasks.',
					stars: 'Flag the highest-priority tasks.',
					statuses: 'Keep track of "where" each task is.',
					subTasks: 'Create a plan by adding sub-tasks.',
					visibility: 'Control how much detail is displayed.',
				},
				opacity: 0.60,
				variant: 'info'
			}
		},
		methods: {
			over(id) {
				
				Object.keys(this.features).forEach((key) => {
					
					if(key != id) {
						this.features[key] = false
					}
				})

				this.features[id] = true
				
				
			}
		},    

}
</script>